/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-06-15 13:50:04
 */
import Excel from 'exceljs'
import type { Fill, Column } from 'exceljs'
import FileSaver from 'file-saver'

interface ColumnConfig {
  name: string
  value: string
  width: number
  size: number
  required?: boolean
}

interface ExcelParams {
  title: string
  subTitle: Array<{ text: string; fontColor?: string }>
  colmuns: ColumnConfig[]
  exportFileName: string
}

export const importExcel = (params: ExcelParams, data: any[]) => {
  // bug： 设置colmuns 字段属性和内容 的时候，当前只能在第一行，
  // 如果需要表头，需要对相关单元格内容进行内容的覆盖
  const fontRequired = { size: 16, bold: true, color: { argb: 'FFFF0202' } }
  const font = { size: 16, bold: true }

  const fill: Fill = {
    type: 'gradient' as const,
    gradient: 'path' as const,
    center: { left: 0.5, top: 0.5 },
    stops: [
      { position: 0, color: { argb: 'FFFCE4D6' } },
      { position: 1, color: { argb: 'FFFCE4D6' } }
    ]
  }

  //创建对象 和 表
  const workbook = new Excel.Workbook()
  const sheet = workbook.addWorksheet('My Sheet')

  let colmunsArray: Partial<Column>[] = []
  const base = 'A'.charCodeAt(0)
  params.colmuns.forEach((item, index) => {
    //设置列属性 字体样式
    colmunsArray.push({
      header: item.name,
      key: item.value,
      width: item.width,
      style: { font: { size: item.size } }
    })
    // 设置内容 填充背景 字体样式
    const num = String.fromCharCode(base + index)
    sheet.getCell(`${num}2`).value = item.name
    sheet.getCell(`${num}2`).fill = fill
    sheet.getCell(`${num}2`).font = item.required ? fontRequired : font
  })
  sheet.columns = colmunsArray

  sheet.getRow(1).height = 50
  sheet.mergeCells('A1', 'F1')
  // 自动换行
  sheet.getCell('A1').alignment = { wrapText: true }
  sheet.getCell('A1').value = {
    // 第二行加入空格符号，换行文本
    richText: [
      {
        font: { size: 18, color: { argb: 'FF305496' }, bold: true },
        text: params.title
      },
      {
        font: { size: 18, color: { argb: 'FF305496' }, bold: true },
        text: '\r'
      },
      // {
      //   font: { size: 12, color: { argb: 'FF305496' }, bold: true },
      //   text: params.subTitle
      // }
      ...params.subTitle.map(({ text, fontColor }) => ({
        font: {
          size: 12,
          color: { argb: fontColor || 'FF305496' },
          bold: true
        },
        text
      }))
    ]
  }

  sheet.addRows(data) // 添加数据

  workbook.xlsx.writeBuffer().then((result) => {
    const blob = new Blob([result], {
      type:
        'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    FileSaver.saveAs(blob, params.exportFileName)
  })
}

export const generateExcelParams = {
  title: '定位失败客户列表：',
  subTitle: [
    {
      text: '失败原因：客户地址信息不完善，'
    },
    {
      text: '无法定位到该地点',
      fontColor: 'FFFF0202'
    },
    {
      text: '。重新编辑后上传，或将该文件导入后，在线调整定位。'
    }
  ],

  // '失败原因：客户地址信息不完善，无法定位到该地点。重新编辑后上传，或将该文件导入后，在线调整定位。',
  colmuns: [
    {
      name: '客户名称', // 表头
      value: 'customerName', // 字段
      required: true, // 是否必选（标红）
      width: 40, // 列表宽度
      size: 14 // 字体尺寸
    },
    {
      name: '客户地点',
      value: 'address',
      required: true,
      width: 40,
      size: 14
    },
    {
      name: '跟进人（手机号）',
      value: 'ownerMobiles',
      required: true,
      width: 40,
      size: 14
    },
    {
      name: '客户联系人姓名',
      value: 'contractName',
      required: false,
      width: 20,
      size: 14
    },
    {
      name: '客户联系人电话',
      value: 'contractTelPhone',
      required: false,
      width: 20,
      size: 14
    }
  ],
  exportFileName: '今日水印相机-定位失败客户.xlsx' // 导出文件名称
}
